/* global cleanDevice */
/**
 * NetSapiens JavaScript Module for interacting with the API dynamically
 *
 * @requires jquery-3.0.0.min.js
 * @returns {object} public methods
 */
var netsapiens = (function () {
  var accessToken;
  var expiresAt;
  var expiresInSeconds;
  var serverName;
  var apiUrl;
  var tokenTimerID;

  /**
   * Sub Module containing - .post() .get() methods default callbacks and error handling
   *
   * @requires jquery-3.0.0.min.js
   * @returns {object} public methods
   */
  var api = (function () {
    var accessInfoPendingPromise = null;
    var lastRequestSuccess = true;

    var tokenTimer = function (seconds) {
      var timeout = seconds * 1000;

      // important: clear old timer - before adding new timer with updated expires_in
      window.clearTimeout(netsapiens.tokenTimerID);

      // run getAccessInfo again after expires_at time has passed client side
      netsapiens.tokenTimerID = window.setTimeout(api.getAccessInfo, timeout);
    };

    var accessInfoSuccess = function (response) {
      var data = JSON.parse(response.responseText);
      var nowUtc = moment.utc();

      expiresAt = moment.unix(data.expires_at).utc();
      expiresInSeconds = expiresAt.diff(nowUtc, 'seconds');

      accessToken = data.access_token;
      serverName = data.server_name;
      apiUrl = data.api_url;

      if (expiresInSeconds > 1) {
        var timerOffsetSeconds = 60;

        if (expiresInSeconds < timerOffsetSeconds) {
          timerOffsetSeconds = expiresInSeconds / 2;
        }

        // pass number of seconds until token expiration calculated by server, offset by 10 sec
        tokenTimer(expiresInSeconds - timerOffsetSeconds);
      }

      if (accessToken) {
        window.localStorage.setItem('access_token', accessToken);
      } else {
        window.localStorage.removeItem('access_token');
      }

      if (expiresInSeconds > 0) {
        window.localStorage.setItem('token_expires_at', expiresAt.unix().toString());
      } else {
        window.localStorage.removeItem('token_expires_at');
      }

      if (serverName) {
        window.localStorage.setItem('server_name', serverName);
      } else {
        window.localStorage.removeItem('server_name');
      }

      if (apiUrl) {
        window.localStorage.setItem('api_url', apiUrl);
      } else {
        window.localStorage.removeItem('api_url');
      }

      // Dispatch accessInfo event
      if (typeof CustomEvent === 'function') {
        var event = new CustomEvent('access-info', { detail: data });

        document.dispatchEvent(event);
      }

      return data;
    };

    // simple function to get current access token from PHP SESSION
    var getAccessInfo = function () {
      if (accessInfoPendingPromise) {
        return accessInfoPendingPromise;
      }

      var promise = new Promise(function (resolve) {
        if (lastRequestSuccess) {
          var url = '/portal/login/token';
          var request = new XMLHttpRequest();

          request.open('POST', url, true);
          request.setRequestHeader(
            'Content-Type',
            'application/x-www-form-urlencoded; charset=UTF-8'
          );

          request.onload = function () {
            var data = accessInfoSuccess(this);

            if (data.access_token) {
              lastRequestSuccess = true;
              accessInfoPendingPromise = null;
              resolve(data);
            } else {
              lastRequestSuccess = false;
              accessInfoPendingPromise = null;
              throw new Error('Error retrieving access token from the current session.');
            }
          };

          request.send();
        } else {
          accessInfoPendingPromise = null;
          throw new Error('Last request to /portal/login/token was not successful');
        }
      });

      accessInfoPendingPromise = promise;

      return promise;
    };

    var getAccessToken = function () {
      return new Promise(function (resolve) {
        var localAccessToken = localStorage.getItem('access_token');
        var tokenExpiresAt = moment.unix(localStorage.getItem('token_expires_at')).utc();
        var nowUtc = moment.utc();

        if (localAccessToken && tokenExpiresAt && tokenExpiresAt.diff(nowUtc, 'seconds') > 60) {
          return resolve(localAccessToken);
        }

        return getAccessInfo()
          .then(function (value) {
            return value.access_token;
          })
          .then(resolve)
          .catch(console.error);
      });
    };

    /**
     * Callback function for AJAX POST to API for error handling
     *
     * @param {object} data: queue data returned from NetSapiens API
     */
    var postError = function (data) {
      console.log(data);

      var status = data.status;
      var warning = data.getResponseHeader('Warning');
      var headers = data.getAllResponseHeaders();

      console.log(headers);

      if (status == 401 && warning == 'The access token provided is invalid.') {
        console.log('execute getAccessInfo');
        getAccessInfo('refresh');
      }
    };

    /**
     * AJAX POST to API
     *
     * @param {object} args: available parameters for the NetSapiens API
     * @param {function} callback: callback function to handle post response
     */
    var post = function (args, successCallback, errorCallback) {
      getAccessToken().then(function (token) {
        apiUrl = window.localStorage.getItem('api_url');

        var server = window.localStorage.getItem('server_name');
        var request = {
          type: 'post'
        };

        // if this is localhost (default) use the server name to avoid errs
        if (apiUrl == 'https://localhost/ns-api/') {
          apiUrl = 'https://' + server + '/ns-api/';
        }

        // If postData field exists, send field data as part of request body
        // instead of as part of the URL
        if (args !== undefined && Object.prototype.hasOwnProperty.call(args, 'postData')) {
          request.data = args.postData;
          delete args.postData;
        }

        if (successCallback == null || successCallback === '') {
          // default success callback
          successCallback = function () {
            console.log('netsapiens.api.post SUCCESS');
          };
        }

        if (errorCallback == null || errorCallback === '') {
          // default error callback
          errorCallback = function (jqXHR, textStatus, errorThrown) {
            console.error('netsapiens.api.post ERROR');
            console.error(errorThrown);
          };
        }

        var query = '?';
        var count = 0;

        Object.keys(args).forEach(function (p) {
          var value = args[p];

          if (p == 'obj') {
            p = 'object';
          }

          // change reserved word to actual string 'object'

          if (p == 'action' && value == 'read') {
            // if action is read enforce json dataType
            request.dataType = 'json';
          }

          var key = p;

          if (count == 0) {
            // first one in query string, so no ampersand necessary
            query += key + '=' + value;
          } else {
            // need ampersand
            query += '&' + key + '=' + value;
          }

          count += 1;
        });

        // format request object
        request.url = apiUrl + query;
        request.headers = {
          Authorization: 'Bearer ' + token
        };

        $.ajax(request)
          .done(successCallback)
          .fail(function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status == 401) {
              $.ajax({
                type: 'post',
                url: '/portal/login/token',
              })
                .done(function () {
                  var data = JSON.parse(this.responseText);
                  var nowUtc = moment.utc();
                  var timerOffsetSeconds = 60;

                  accessToken = data.access_token;
                  serverName = data.server_name;

                  apiUrl = data.api_url;
                  expiresAt = moment.unix(data.expires_at).utc();
                  expiresInSeconds = expiresAt.diff(nowUtc, 'seconds');

                  if (expiresInSeconds < timerOffsetSeconds) {
                    timerOffsetSeconds = expiresInSeconds / 2;
                  }

                  if (expiresInSeconds > 0) {
                    // pass number of seconds until token expiration calculated by server
                    // offset by 10 sec
                    tokenTimer(expiresInSeconds - timerOffsetSeconds);
                  }

                  window.localStorage.setItem('access_token', data.access_token);
                  window.localStorage.setItem('server_name', data.server_name);
                  window.localStorage.setItem('api_url', data.api_url);

                  if (data.ns_t) {
                    window.localStorage.setItem('ns_t', data.ns_t);
                  }

                  // Dispatch accessInfo event
                  if (typeof CustomEvent === 'function') {
                    var event = new CustomEvent('access-info', { detail: data });

                    document.dispatchEvent(event);
                  }

                  request.headers = {
                    Authorization: 'Bearer ' + accessToken,
                  };

                  $.ajax(request)
                    .fail(postError);
                });
            }

            // custom error callback
            errorCallback(jqXHR, textStatus, errorThrown);
          });
      });
    };

    return {
      post: post,
      getAccessInfo: getAccessInfo,
      accessToken: accessToken,
      getAccessToken: getAccessToken
    };
  }());

  var init = function () {
    api.getAccessInfo();
  };

  return {
    init: init,
    api: api,
    tokenTimerID: tokenTimerID
  };
}());

// END NETSAPIENS MODULE
$(function () {
  // initialize
  netsapiens.init();
});

/**
 * Autocomplete sub module
 *
 * @requires jquery-3.0.0.min.js
 * @returns {object} public methods: getPermutations()
 */
netsapiens.autocomplete = (function () {
  // populated by PHP on page load in portal layout
  var domainList = {};
  // populated by PHP on page load in portal layout
  var resellerList = {};
  var loadingHtml = '';
  var callBackId;

  var init = function () {
    console.log('init');
  };

  /**
   * Cross checks a domain against domainList passed from PHP
   * domainList is json object with [{domain: description}] key/value format
   *
   * @param {string} d: netsapiens domain name
   */
  var checkDomain = function (d) {
    var i;
    var keys = Object.keys(this.domainList);

    for (i = 0; i < keys.length; i += 1) {
      if (d == keys[i]) {
        return true;
      }
    }

    return false;
  };

  /**
   * Cross checks a domain against domainList passed from PHP
   * domainList is json object with [{domain: description}] key/value format
   *
   * @param {string} d: netsapiens domain name
   */
  var checkReseller = function (d) {
    var i;
    var keys = Object.keys(this.resellerList);

    for (i = 0; i < keys.length; i += 1) {
      if (d == keys[i]) {
        return true;
      }
    }

    return false;
  };

  /**
   * Generate an autocomplete of extensions for a domain
   * -- could be converted to sub module pattern
   *
   * @param {string} d: HTML dom input element id of field with domain value
   * @param {string} e: HTML dom input element id of field to hold autocomplete of extensions
   * @param {boolean} [n]: name true or false whether to display the name with
   * extension as: 'extension (first last)'
   */
  var extensions = function (d, e, n) {
    if (!n) {
      // if n parameter is not passed set to false
      n = false;
    }

    var domain = document.getElementById(d);

    if (!domain || !e) {
      // return error
      throw new ReferenceError('invalid domain or extension field', 'netsapiens.js', 170);
    }

    /**
     * Creates autocompleted for the extension input field
     * Private function - Callback for API Post
     *
     * @param {object} data: return object from the api
     *
     * @private
     */
    var extAutoComp = function (data) {
      var exts = [];

      Object.keys(data).forEach(function (key) {
        var str = data[key].user;

        if (data[key].first_name && data[key].last_name) {
          // add name if in returned data
          str += ' (' + data[key].first_name + ' ' + data[key].last_name + ')';
        }

        exts.push(str);
      });

      // remove loadingHtml
      $('.app-details-loading').remove();
      $('#' + e).autocomplete({
        minLength: 0,
        source: exts
      });
    };

    /**
     * Checks for valid domain and posts a request to api if valid
     * Private function - Callback for changes to domain input
     *
     * @private
     */
    var callback = function () {
      // split by whitespace first in returned array
      var dom = domain.value.split(' ')[0];
      var check = netsapiens.autocomplete.checkDomain(dom);

      if (dom != '' && check === true) {
        var args = {
          obj: 'subscriber',
          action: 'read',
          domain: dom,
          fields: 'user'
        };

        // if show name is true get name fields too
        if (n === true) {
          args.fields = 'user,first_name,last_name';
        }

        $(loadingHtml).insertAfter('#' + e);
        netsapiens.api.post(args, extAutoComp);
      } else {
        netsapiens.autocomplete.remove(e);
      }
    };

    domain.addEventListener('input', callback);
    $(domain).on('autocompleteclose', callback);
  };

  /**
   * Generate an autocomplete of devices for a given domain
   * -- could be converted to sub module pattern
   *
   * @param {string} domId: HTML dom input element id of field with domain value
   * @param {string} devId: HTML dom input element id of field to hold autocomplete of devices
   */
  var devices = function (domId, devId) {
    var domain = document.getElementById(domId);
    var device = document.getElementById(devId);
    var loaded = '';

    /**
     * Creates autocomplete for the device input field
     * Private function - Callback for API Post
     *
     * @param {object} data: return object from the api
     *
     * @private
     */
    var devAutoComp = function (data) {
      // the autocomplete for this value is loaded
      loaded = domain.value.split(' ')[0];

      var deviceList = [];

      Object.keys(data).forEach(function (key) {
        // cleanDevice() defined in scripts.js
        var s = cleanDevice(data[key].aor) + ' (' + data[key].sub_fullname + ')';

        deviceList.push(s);
      });

      // remove loadingHtml
      $('.app-details-loading').remove();
      $('#' + device.id).autocomplete({
        minLength: 0,
        source: deviceList
      });
    };

    /**
     * Checks for valid domain and posts a request to api if valid
     * Private function - Callback for changes to domain input
     *
     * @private
     */
    var callback = function () {
      // split by whitespace first in returned array
      var dom = domain.value.split(' ')[0];

      // This is the currently loaded autcomplete
      if (dom == loaded) {
        return;
      }

      var check = netsapiens.autocomplete.checkDomain(dom);

      if (dom != '' && check === true) {
        var args = {
          obj: 'device',
          action: 'read',
          owner_domain: dom
        };

        $(loadingHtml).insertAfter('#' + device.id);
        netsapiens.api.post(args, devAutoComp);
      } else {
        netsapiens.autocomplete.remove(device.id);
      }
    };

    if (!domain || !device) {
      // return error
      throw new ReferenceError('invalid domain or device field', 'netsapiens.js', 170);
    }

    domain.addEventListener('input', callback);
    $(domain).on('autocompleteclose', callback);
  };

  var userCallback = function (data) {
    var users = [];

    Object.keys(data).forEach(function (key) {
      var string = data[key].user + ' (' + data[key].first_name + ' ' + data[key].last_name + ')';

      users.push(string);
    });

    // remove loadingHtml
    $('.app-details-loading').remove();
    $('#' + callBackId).autocomplete({ minLength: 0, source: users });

    // reset to empty string
    callBackId = '';
  };

  var domainCallBack = function (data) {
    var domains = [];

    Object.keys(data).forEach(function (key) {
      var string = data[key].domain + ' (' + data[key].description + ')';

      domains.push(string);
    });

    // remove loadingHtml
    $('.app-details-loading').remove();
    $('#' + callBackId).autocomplete({ minLength: 0, source: domains });

    // reset to empty string
    callBackId = '';
  };

  var voicemailCallback = function (data) {
    var users = [];

    Object.keys(data).forEach(function (key) {
      var string = data[key].user + ' (' + data[key].first_name + ' ' + data[key].last_name + ')';

      users.push(string);
    });

    // remove loadingHtml
    $('.app-details-loading').remove();
    $('#' + callBackId).autocomplete({ minLength: 0, source: users });
    // reset to empty string
    callBackId = '';
  };

  var conferenceCallback = function (data) {
    // Relabel for jquery autocomplete expected
    // format [ { label: "Choice1", value: "value1" }, ... ]
    var labeled = [];

    Object.keys(data).forEach(function (key) {
      var obj = data[key];
      obj.label = obj.name + ' (' + obj.owner.toString() + ')';
      obj.value = obj.aor;

      delete obj.name;
      delete obj.aor;
      delete obj.owner;
      labeled.push(obj);
    });

    // remove loadingHtml
    $('.app-details-loading').remove();
    $('#' + callBackId).autocomplete({ minLength: 0, source: labeled });
    // reset to empty string
    callBackId = '';
  };

  var queueCallback = function (data) {
    var queues = [];

    Object.keys(data).forEach(function (key) {
      var string = data[key].queue_name + ' (' + data[key].description + ')';

      queues.push(string);
    });

    // remove loadingHtml
    $('.app-details-loading').remove();
    $('#' + callBackId).autocomplete({ minLength: 0, source: queues });
  };

  var attendantCallback = function (data) {
    $('#available_attendants').find('option')
      .remove()
      .end();

    var users = [];

    Object.keys(data).forEach(function (key) {
      var string = data[key].mainname + ' (' + data[key].user + ')';
      var string2 = data[key].user + '@' + data[key].starting;

      $('#available_attendants').append('<option value="' + string + '">' + string2 + '</option>');
      users.push(string);
    });

    // remove loadingHtml
    $('.app-details-loading').remove();
    $('#' + callBackId).autocomplete({ minLength: 0, source: users });
    // reset to empty string
    callBackId = '';
  };

  /**
   * Autocomplete helper function used mostly for inventory views
   * -- run when a "treatment" field with options for "user", "fax", "callqueue" etc
   * -- builds objects, calls api based on user selection and performs autocomplete callback
   *
   * @param {object} e: JavaScript user event data
   * @param {string} d: HTML dom input element id of field with domain value
   */
  var updateTreatment = function (e, d) {
    var domain = document.getElementById(d);
    var reseller = document.getElementById(d);
    var val = e.target.value;
    var dom = domain.value.split(' ')[0];
    var res = reseller.value.split(' ')[0];
    var subscriber = {
      obj: 'subscriber',
      action: 'read',
      domain: dom,
      fields: 'user,first_name,last_name',
      filter_users: 'departments,system,domain',
      format: 'json'
    };

    var domainArgs = {
      obj: 'domain', action: 'read', territory: res, fields: 'domain', format: 'json'
    };

    var conference = {
      obj: 'conference',
      action: 'read',
      owner_domain: dom,
      fields: 'name,aor,owner',
      filter_bridges: 'video',
      format: 'json'
    };

    var callQueue = {
      obj: 'callqueue',
      action: 'read',
      domain: dom,
      fields: 'queue_name,description',
      format: 'json'
    };

    var attendant = {
      obj: 'attendant', action: 'read', domain: dom, fields: '*', format: 'json'
    };

    var args;
    var callback;

    // route to actions based on event target (treatment <input>) value
    switch (val) {
      case 'available':
        // do nothing
        return;
      case 'user':
        args = subscriber;
        callback = userCallback;

        break;
      case 'domain':
        args = domainArgs;
        callback = domainCallBack;

        break;
      case 'fax':
        args = subscriber;
        callback = userCallback;

        break;
      case 'conference':
        args = conference;
        callback = conferenceCallback;

        break;
      case 'callqueue':
        args = callQueue;
        callback = queueCallback;

        break;
      case 'voicemail':
        args = subscriber;
        callback = voicemailCallback;
        val = 'vmail';

        break;
      case 'attendant':
        args = attendant;
        callback = attendantCallback;

        break;
      case 'trunk':
        // handled by PHP currently
        return;
      default:
    }

    callBackId = val + '-choices';

    if ($('.app-details-loading').length == 0) {
      $(loadingHtml).insertAfter('#' + callBackId);
    }

    netsapiens.api.post(args, callback);
  };

  /**
   * Removes an autocomplete via destroy() jquery api method,
   * also resets input value to empty string
   *
   * @param {string} id: input field id
   */
  var remove = function (id) {
    var selector = '#' + id;

    // if the field has an autocomplete, destroy
    if ($(selector).hasClass('ui-autocomplete-input')) {
      $(selector).autocomplete('destroy');
    }

    selector.value = '';
  };

  return {
    domainList: domainList,
    resellerList: resellerList,
    init: init,
    checkDomain: checkDomain,
    checkReseller: checkReseller,
    extensions: extensions,
    devices: devices,
    updateTreatment: updateTreatment,
    remove: remove,
    loadingHtml: loadingHtml
  };
}());
// END AUTOCOMPLETE SUB MODULE

/**
 * Permutations Javascript Module
 *
 * @returns {object} public methods: getPermutations()
 */
netsapiens.permutate = (function () {
  var results = [];

  function doPermute(input, output, used, size, level) {
    if (size == level) {
      var word = output.join('');

      results.push(word);

      return;
    }

    level += 1;

    for (var i = 0; i < input.length; i += 1) {
      if (!used[i]) {
        used[i] = true;
        output.push(input[i]);
        doPermute(input, output, used, size, level);
        used[i] = false;
        output.pop();
      }
    }
  }

  return {
    getPermutations: function (input, size) {
      // reset to empty array every call
      results = [];

      var chars = input.split('');
      var output = [];
      var used = new Array(chars.length);

      doPermute(chars, output, used, size, 0);

      return results;
    }
  };
}());
// END PERMUTATE SUB MODULE

/**
 * Clean Device Helper Function
 *
 * @param   {string} str:
 * @returns {string} str: formatted, cleaned string of numbers
 *                           i.e. 18587645200ds => 1 (858) 764-5200, 5224wp => 5224 etc.
 */
netsapiens.cleanDevice = function (str) {
  if (typeof str === 'undefined' || str == null) {
    return '';
  }

  // Remove characters
  str = str.replace('sip', '');
  str = str.replace(':', '');
  str = str.replace('+', '');
  str = str.replace('(', '');
  str = str.replace(')', '');
  str = str.replace('-', '');
  str = str.replace(/\./g, '');
  str = str.replace(/:/g, '');
  str = str.replace(/ /g, '');
  str = str.replace(/\+/g, '');
  str = str.replace(/\(/g, '');
  str = str.replace(/\)/g, '');
  str = str.replace(/-/g, '');
  str = str.replace(/^\s+|\s+$/g, '');
  str = str.replace('wp', '');

  var group = str.split('@');

  str = group[0];
  str = str.replace('%40', '@');

  group = str.split('@');

  str = group[0];

  // Formatting based on number of digits, tests string has numbers first
  if (/^\d+$/.test(str)) {
    if (str.length == 11 && str[0] == '1') {
      return '1 (' + str.substring(1, 4) + ') ' + str.substring(4, 7) + '-' + str.substring(
        7,
        11
      );
    }

    if (str.length == 10 && str[0] != '0' && str[0] != '1') {
      return '(' + str.substring(0, 3) + ') ' + str.substring(3, 6) + '-' + str.substring(6, 10);
    }

    if (str.length == 7) {
      return str.substring(0, 3) + '-' + str.substring(3, 7);
    }

    return str;
  }

  return str;
};
